import { FC } from 'react';
import {
  BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer,
} from 'recharts';
import { ChartEmptyState } from '../../AthleteInjuryCharts/charts/_shared/ChartEmptyState';
import { ITeamLeaderboardMetric } from '../../../../models/injury';
import {
  chartAxisTick,
  chartGridProps,
  chartTooltipContentStyle,
  chartTooltipItemStyle,
  chartTooltipLabelStyle,
} from '../../../../shared/charts/chartTheme';

interface Props {
  data: ITeamLeaderboardMetric | null;
}

export const TeamLeaderboardChart: FC<Props> = ({ data }) => {
  if (!data?.data?.length) return <ChartEmptyState />;

  const chartData = [...data.data]
    .sort((a, b) => b.totalDaysLost - a.totalDaysLost)
    .slice(0, 5)
    .map((d) => ({
      name: `${d.firstName} ${d.lastName.charAt(0)}.`,
      days: d.totalDaysLost,
      injuries: d.totalInjuries,
    }));

  return (
    <ResponsiveContainer width="100%" height={200}>
      <BarChart
        layout="vertical"
        data={chartData}
        margin={{ top: 4, right: 40, left: 4, bottom: 0 }}
      >
        <CartesianGrid {...chartGridProps} vertical horizontal={false} />
        <XAxis type="number" tick={chartAxisTick} />
        <YAxis dataKey="name" type="category" width={80} tick={chartAxisTick} />
        <Tooltip
          contentStyle={chartTooltipContentStyle}
          labelStyle={chartTooltipLabelStyle}
          itemStyle={chartTooltipItemStyle}
          formatter={(v, _, props) => [
            `${v} gg persi · ${props.payload.injuries} infortuni`,
            'Atleta',
          ]}
        />
        <Bar dataKey="days" fill="var(--c-text-0)" radius={[0, 4, 4, 0]} />
      </BarChart>
    </ResponsiveContainer>
  );
};
